const REFETCH_TEST_CASE_LIST = 'REFETCH_TEST_CASE_LIST';

const EVENT_TYPES = {
  REFETCH_TEST_CASE_LIST,
};

export default EVENT_TYPES;
